export default (api, resource) => ({

    getAll: async ({token,rota,params}) => {
        let url = `${resource}/encontrar?funcao=`
        
        if (rota && rota === 'admins'){
            url = `${url}ADMIN&pagina=${params.pagina}&quantidade=${params.quantidade}`
        }

        if(rota && rota === 'gestores'){
            url = `${url}GESTOR&pagina=${params.pagina}&quantidade=${params.quantidade}`
        }
        if (rota && rota === 'gerenteSecao'){
            url = `${url}GERENTE_SECAO&pagina=${params.pagina}&quantidade=${params.quantidade}`
        }

        if(rota && rota === 'operadores'){
            url = `${url}OPERADOR&pagina=${params.pagina}&quantidade=${params.quantidade}`
        }

        if(rota && rota === 'recolhe'){
            url = `${url}RECOLHE&pagina=${params.pagina}&quantidade=${params.quantidade}`
        }

        if(rota && rota === 'pos'){
            url = `${url}POS&pagina=${params.pagina}&quantidade=${params.quantidade}`
        }

        if(rota && rota === 'programadores'){
            url = `${url}PROGRAMADOR&pagina=${params.pagina}&quantidade=${params.quantidade}`
        }

        const response = await api.get(url, {
            headers: {
              Authorization: token
            } 
        })
           
        return {
          data: response.data
        }
    },


    updateUser: async ({user, rota, token}) => {
       let url = `${resource}/${user.id}/atualizar`

        if( rota && rota === 'gerenteSecao'){
            url = `${resource}/section-manager/${user.id}/atualizar`
        }
        const response = await api.put(url,{
            ...user
        },
        {
            headers:{
                Authorization:token
            }
        })

        return {
          data: response.data
        }
    },
})